import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

export const AppShell = ({ title, subtitle, actions, children, testid }) => (
  <>
    <Navbar solid />
    <main className="page-wrap" data-testid={testid}>
      <div className="container">
        {(title || actions) && (
          <div className="page-head">
            <div>
              {title && <h1>{title}</h1>}
              {subtitle && <p>{subtitle}</p>}
            </div>
            {actions}
          </div>
        )}
        {children}
      </div>
    </main>
    <Footer />
  </>
);

export default AppShell;
